import { HighlightRule } from '../types/highlights'

export const defaultRules: HighlightRule[] = [
  {
    id: 'rule-lock-7',
    targetFieldId: 'rateLockExp',
    sourceFieldId: 'rateLockExp',
    operator: 'within_days',
    value: '7',
    tone: 'critical',
    flag: 'Expiring',
    enabled: true,
  },
  {
    id: 'rule-dti-45',
    targetFieldId: 'dti',
    sourceFieldId: 'dti',
    operator: 'gt',
    value: '45',
    tone: 'critical',
    flag: 'Over 45%',
    enabled: true,
  },
  {
    id: 'rule-ltv-80',
    targetFieldId: 'ltv',
    sourceFieldId: 'cltv',
    operator: 'gt',
    value: '80',
    tone: 'warning',
    flag: 'MI req.',
    enabled: true,
  },
  {
    id: 'rule-fico-780',
    targetFieldId: 'fico',
    sourceFieldId: 'fico',
    operator: 'gte',
    value: '780',
    tone: 'positive',
    enabled: true,
  },
  {
    id: 'rule-program-empty',
    targetFieldId: 'loanProgram',
    sourceFieldId: 'loanProgram',
    operator: 'is_empty',
    tone: 'warning',
    flag: 'Not set',
    enabled: true,
  },
  {
    id: 'rule-status-uw',
    targetFieldId: 'currentLoanStatus',
    sourceFieldId: 'conditionsOutstanding',
    operator: 'gte',
    value: '5',
    tone: 'info',
    flag: 'Conditions',
    enabled: true,
  },
]
